
import { Dealer } from "@/types/dealer";
import { DealerFilterState } from "./types";
import { calculateDistance } from "@/lib/geolocation";

/**
 * Filter dealers based on filter criteria
 */
export const filterDealers = (
  dealers: Dealer[], 
  filters: DealerFilterState, 
  coordinates: { latitude: number; longitude: number } | null
): Dealer[] => {
  return dealers.filter((dealer: Dealer) => {
    // Filter by verified status
    if (filters.filterVerified && !(dealer.activated ?? false)) return false;
    
    // Filter by activated status, if enabled
    if (filters.filterActivated && !(dealer.activated ?? false)) return false;
    
    // Filter by name search
    if (
      filters.search &&
      !dealer.name.toLowerCase().includes(filters.search.toLowerCase())
    )
      return false;
    
    // Filter by rating range
    if (
      dealer.rating &&
      (filters.range[0] > dealer.rating || filters.range[1] < dealer.rating)
    )
      return false;
    
    // Filter by distance if coordinates are available and distance filter is set (not 0)
    if (coordinates && filters.distanceRange > 0) {
      const distance = calculateDistance(
        coordinates.latitude,
        coordinates.longitude,
        dealer.latitude,
        dealer.longitude
      );
      if (distance > filters.distanceRange) return false;
    }
    
    return true;
  });
};

/**
 * Sort dealers based on sort criteria
 */
export const sortDealers = (
  dealers: Dealer[], 
  sortOrder: string, 
  coordinates: { latitude: number; longitude: number } | null
): Dealer[] => {
  return [...dealers].sort((a: Dealer, b: Dealer) => {
    // If sorting by distance and we have user coordinates
    if (sortOrder === "distance" && coordinates) {
      const distanceA = calculateDistance(
        coordinates.latitude,
        coordinates.longitude,
        a.latitude,
        a.longitude
      );
      const distanceB = calculateDistance(
        coordinates.latitude,
        coordinates.longitude,
        b.latitude,
        b.longitude
      );
      return distanceA - distanceB;
    }
    
    // Fall back to rating sorting if no coordinates or not sorting by distance
    const ratingA = a.rating || 0;
    const ratingB = b.rating || 0;
    return sortOrder === "asc" ? ratingA - ratingB : ratingB - ratingA;
  });
};
